import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function useTableState(suffix = '', { defaultSorting = [] } = {}) {
    const location = useLocation();
    const storageKey = `table_${location.pathname}${suffix ? `_${suffix}` : ''}`;
    const saved = sessionStorage.getItem(storageKey);
    const initial = saved ? JSON.parse(saved) : {};
    const [globalFilter, setGlobalFilter] = useState(initial.globalFilter ?? '');
    const [sorting, setSorting] = useState(initial.sorting ?? defaultSorting);
    const [pagination, setPagination] = useState(initial.pagination ?? { pageIndex: 0, pageSize: 25 });
    const [columnFilters, setColumnFilters] = useState(initial.columnFilters ?? []);

    useEffect(() => {
        sessionStorage.setItem(storageKey, JSON.stringify({ globalFilter, sorting, pagination, columnFilters }));
    }, [globalFilter, sorting, pagination, columnFilters, storageKey]);

    return { globalFilter, setGlobalFilter, sorting, setSorting, pagination, setPagination, columnFilters, setColumnFilters };
}
